module.exports = __webpack_public_path__ + "img/1561422608.272ab4cc.jpg";